import React from 'react'
import { Box, Button, Card, CircularProgress, Container, Divider, Drawer, Grid, TextField, Typography } from '@mui/material'
import deleteIcon from '../../assets/images/deleteIcon.png'
import addressIcon from '../../assets/images/addressLocation.svg'
import cartImage from '../../assets/images/cartEmpty.webp'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../reduxState/store'
import { Gallery_BASE_URL } from '../../config'
import { fetchCarts, clearState as clearCartData } from '../../reduxState/cartSlice/cartGetallSlice'
import { deleteCartById, clearDeleteState } from '../../reduxState/cartSlice/cartDeleteSlice'
import { updateCartById, clearUpdateState } from '../../reduxState/cartSlice/cartUpdateSlice'
import { fetchAddress } from '../../reduxState/addressSlice/addressGetallSlice'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { orderAdd, clearState } from '../../reduxState/orderSlice/orderDetailsAdd'
import { fetchCoupon } from '../../reduxState/couponSlice/couponGetallSlice'
import AppSnackbar from '../commonToast/customizeAlert'
import { fetchOffer } from '../../reduxState/offers/offersGetall'
import promoCode from '../../assets/images/promoCode.png'
import Swal from 'sweetalert2'
import merchantlogoEmpty from '../../assets/images/merchantlogoEmpty.webp'
import productEmpty from '../../assets/images/productEmpty.webp'
import GoToTop from '../commonToast/ontopScroll'
import useRazorpay from "react-razorpay";
import paymentImg from '../../assets/images/fav-icon.png'
import AddAddress from '../orderPage/address/addAddress'
import newAddress from '../../assets/images/newAddress.svg'
import offersEmpty from '../../assets/images/offersEmpty.png'

type Anchor = 'right';

const CartAddList: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate()
  const location = useLocation()
  const cartProducts = useSelector((state: RootState) => state.cartList);
  // const couponList = useSelector((state: RootState) => state.couponList);
  const offerList = useSelector((state: RootState) => state.offerList);
  const cartDelete = useSelector((state: RootState) => state.cartDelete);
  const cartUpdate = useSelector((state: RootState) => state.cartUpdate);
  const address = useSelector((state: RootState) => state.addressList);
  const orderDetails = useSelector((state: RootState) => state.orderAdd);
  const addressAdd = useSelector((state: RootState) => state.addressAdd);
  const [state, setState] = React.useState({
    right: false,
  });
  const CouponCode: any = localStorage.getItem("CODE") ? localStorage.getItem("CODE") : ''
  const OfferCode: any = localStorage.getItem("OFFER") ? localStorage.getItem("OFFER") : ''
  const CouponApply = localStorage.getItem("COUPON") ? localStorage.getItem("COUPON") : ''
  const OfferApply = localStorage.getItem("OFFERID") ? localStorage.getItem("OFFERID") : ''
  const [indexLoading, setIndexLoading] = React.useState<any>('')
  const [deletIndexLoading, setDeleteIndexLoading] = React.useState<any>('')
  const [isSnackbarOpen, setIsSnackbarOpen] = React.useState(false);
  const [isErrorSnackbarOpen, setIsErrorSnackbarOpen] = React.useState(false);
  const [Razorpay] = useRazorpay();
  const [payment, setPayment] = React.useState<any>('')
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  //cart details alert
  React.useEffect(() => {
    if (location.pathname = "/product-cart/list") {
      if (cartUpdate.code === 200 || orderDetails.code === 200 || cartDelete.code === 200) {
        setIsSnackbarOpen(true);
      }
    }
  }, [cartUpdate.code, cartDelete.code, orderDetails.code, location.pathname]);

  React.useEffect(() => {
    const branchId = cartProducts?.data[0]?.productDetails?.branch?.id
    if (branchId) {
      dispatch(fetchOffer({ branchId: branchId ? branchId : '' }))
    }
  }, [cartProducts?.data[0]?.productDetails?.branch?.id])

  // coupon/offer apply dispatch
  React.useEffect(() => {
    dispatch(fetchCarts({ status: 'ACTIVE', coupenCodeId: CouponApply, offerId: OfferApply, coupenOfferRemove: null }))
    dispatch(fetchCoupon(''))
  }, [cartDelete.code && cartDelete.loading, cartUpdate.code && cartUpdate.loading, CouponApply, OfferApply])

  // Coupon/offer remove
  const removeCoupon = () => {
    dispatch(fetchCarts({ status: 'ACTIVE', coupenCodeId: CouponApply, offerId: OfferApply, coupenOfferRemove: true }))
    localStorage.setItem("OFFERID", '')
    localStorage.setItem("COUPON", '')
  }

  React.useEffect(() => {
    dispatch(fetchAddress(''))
  }, [addressAdd.code])

  // after payment success navigation to orders page
  React.useEffect(() => {
    if (orderDetails.code === 200 && orderDetails.data) {
      const orderId = orderDetails.data
      setPayment('')
      setTimeout(() => {
        navigate("/orderPage")
        localStorage.setItem("OFFERID", '')
        localStorage.setItem("COUPON", '')
        dispatch(clearState())
        dispatch(clearCartData())
        // dispatch(clearCartById(orderId))
      }, 3000)
    }
  }, [orderDetails.code])

  // Order place after payment
  React.useEffect(() => {
    if (payment !== '') {
      let addressId = address.data.find((obj: any) => {
        if (obj.isDefault) {
          return obj
        }
      });
      let NewArray: Array<any> = []
      cartProducts.data.find((obj: any) => {
          const products = {
            branchId: obj.productDetails.branch.id,
            prdId: obj.productDetails.id,
            prdPrice: obj.variantDetails.price ? obj.variantDetails.price : obj.productDetails.price,
            prdQty: obj.cartCount,
            varId: obj.variantDetails.variant.id
          }
          NewArray.push(products)
      });
      const payload: any = {
        coupenId: CouponApply,
        offerId: OfferApply,
        coupenAmount: cartProducts?.billDetails?.coupenAmount ? cartProducts?.billDetails?.coupenAmount : 0,
        offerAmount: cartProducts?.billDetails?.offerAmount ? cartProducts?.billDetails?.offerAmount : 0,
        dlvAddrs: addressId?.id,
        dlvCharges: cartProducts?.billDetails?.dlvCharges,
        isCoupenApplied: cartProducts?.billDetails?.isCoupenApplied ? cartProducts?.billDetails?.isCoupenApplied : false,
        isOfferApplied: cartProducts?.billDetails?.isOfferApplied ? cartProducts?.billDetails?.isOfferApplied : false,
        items: NewArray,
        paymentMode: 'Upi',
        subTotalAmt: cartProducts?.billDetails?.subTotalAmt,
        totAmt: cartProducts?.billDetails?.totAmt
      }
      dispatch(orderAdd(payload))
    }
  }, [cartProducts.code, address.code, payment])

  const toggleDrawer = (anchor: Anchor, open: boolean, coupon?: any) => (
    event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
    if (coupon) {
      let Code: any = document.getElementById(coupon.id)?.innerHTML
      localStorage.setItem("CODE", Code)
      localStorage.setItem("COUPON", coupon.id)
    }
  };

  const toggleDrawerOffer = (anchor: Anchor, open: boolean, offer?: any) => (
    event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
    if (offer) {
      let Offer: any = document.getElementById(offer.id)?.innerHTML
      localStorage.setItem("OFFER", Offer)
      localStorage.setItem("OFFERID", offer.id)
    }
  };

  // Coupon/offer drawer section 
  const list = (right: Anchor) => (
    <Box
      className="toggle-width"
      role="presentation"
    >
      {offerList?.data.filter(offers => !offers.isApplied).length > 0 ?
        <>
          <Typography textAlign={'center'} mt={2} className='reem-kulfi drawer-head'>Offers</Typography>
          <Grid container justifyContent={'center'} gap={2} p={3}>
            {offerList?.data?.map((offers, index) => (
              !offers.isApplied ?
                <Grid item xs={11} component={Card} key={index} className='address-list'>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}} p={2}>
                      <>
                      {offers?.offerImage?.filePath === null ? <img src={promoCode} alt="PromoCode image" className='promocode-cart' style={{objectFit:'contain'}} loading='lazy' /> :
                      <img src={`${Gallery_BASE_URL}${offers?.offerImage?.filePath}`} alt="PromoCode image" className='promocode-cart' style={{borderRadius:'50%', objectFit:'cover'}} loading='lazy' />}
                      </>
                    <Box width={'63%'}>
                      <Box sx={{ display: 'flex' }}>
                        <Typography className='promo-card-header reem-kulfi' id={offers.id} sx={{ paddingRight: '6px', whiteSpace:'nowrap' }}>{offers?.offerName}</Typography>
                        <Divider orientation="vertical" variant="middle" flexItem />
                        <Typography className='promo-card-header reem-kulfi' sx={{ paddingLeft: '6px', borderLeft: '1px solid #000000' }}>{offers.offerPerc}%</Typography>
                      </Box>
                      <Typography className='promo-card-code roboto-med'>{offers.offerDesc}</Typography>
                    </Box>
                    <Button variant='contained' className='promo-button' onClick={toggleDrawerOffer(right, false, offers)}>Apply</Button>
                  </Box>
                </Grid> : null
            ))}
          </Grid>
        </> : 
        <Box textAlign={'center'} mt={5} pt={5} height={'80vh'}>
          <img src={offersEmpty} alt='offers empty State' className='offersEmpty' />
        </Box>}
      {/* {couponList?.data.length > 0 ?
        <>
          <Typography textAlign={'center'} mt={2} className='reem-kulfi drawer-head'>Coupons</Typography>
          <Grid container justifyContent={'center'} gap={2} p={3}>
            {couponList?.data?.map((promocode, index) => (
              !promocode.isUsed ? 
              <Grid item xs={11} component={Card} key={index} className='address-list'>
                <Box px={3} p={3}>
                  <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} className='promocode-list' p={0.25}>
                    <Typography className='promo-head roboto-med' sx={{ width: '50%', textAlign: 'center', color: '#FB640A' }} id={promocode.id}>{promocode?.coupenCode}</Typography>
                    <Button variant='contained' className='promo-button' onClick={toggleDrawer(right, false, promocode)}>Apply</Button>
                  </Box>
                  <Box mt={1}>
                    <Typography className='promo-description roboto-med'>{promocode?.coupenDesc}</Typography>
                  </Box>
                </Box>
              </Grid> : null
            ))}
          </Grid>
        </> : null} */}
    </Box>
  )

  const validationSchema = yup.object().shape({
    coupon: yup.string().required(''),
  });

  const { control, reset } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      coupon: '',
    },
  });

  // product add
  const handleAddCart = (cart: any, index: any) => {
    setIndexLoading(index)
    const cartId = cart.id
    const variantId = cart.variantDetails.variant.id
    const productId = cart.productDetails.id
    const payload: any = {
      cart: false,
      productId: productId,
      quantity: "add",
      variantId: variantId
    }
    payload.id = cartId
    dispatch(updateCartById(payload))
  }

  // product sub
  const handleSubCart = (cart: any, index: any) => {
    setIndexLoading(index)
    const cartId = cart.id
    const variantId = cart.variantDetails.variant.id
    const productId = cart.productDetails.id
    const cartCount = cart.cartCount
    const payload: any = {
      cart: true,
      productId: productId,
      quantity: "sub",
      variantId: variantId
    }
    payload.id = cartId
    if (cartCount === 1) {
      dispatch(updateCartById(payload))
    } else {
      dispatch(updateCartById(payload))
    }
  }

  const handleDeleteCart = (cart: any, index:any) => {
    setDeleteIndexLoading(index)
    dispatch(deleteCartById(cart))
  }

  const handleChangeDeliveryAddress = () => {
    navigate("/orderPage", { state: 1 })
  }

  const backtoAddproduct = () => {
    const data = {
      id: cartProducts?.data[0] && cartProducts?.data[0]?.productDetails?.branch?.id,
      type: 'product'
    }
    navigate("/merchant-product/list", { state: data })
  }

  // payment process
  const handleCheckout = (address: any, cartProducts: any) => {
    if (cartProducts.count > 0 && address.data.length > 0) {
      const contactName = address.data.find((obj: any) => {
        return obj.isDefault === true;
      }).contactName;
      const contactNo = address.data.find((obj: any) => {
        return obj.isDefault === true;
      }).contactNo;
      try {
        const options: any = {
          key: "rzp_test_qm24X8q6IHQZc7",
          amount: cartProducts?.billDetails?.subTotalAmt * 100,
          currency: "INR",
          name: "Food Delivery Shenll",
          description: "Test Transaction",
          image: paymentImg,
          handler: (res: any) => {
            setPayment(res.razorpay_payment_id)
          },
          prefill: {
            name: contactName,
            email: "youremail@example.com",
            contact: contactNo,
          },
          notes: {
            address: "Razorpay Corporate Office",
          },
          theme: {
            color: "#FB640A",
          },
        };
        const rzpay = new Razorpay(options);
        rzpay.open();
      } catch (error) {
        Swal.fire({
          title: 'Error creating order',
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#FB640A",
        })
      }
    } else if (cartProducts.count > 0) {
      Swal.fire({
        title: address.message,
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#FB640A",
      }).then((result) => {
        if (result.isConfirmed) {
          setIsModalOpen(true);
        }
      })
    } else {
      Swal.fire({
        title: cartProducts.message,
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#FB640A",
      })
    }
  }

  const handleSnackbarClose = () => {
    setIsSnackbarOpen(false);
    setIsErrorSnackbarOpen(false);
    dispatch(clearDeleteState())
    dispatch(clearUpdateState())
  };

  const handleAddAddress = () => {
    setIsModalOpen(true)
  }

  const handleAddressModalClose = (event: React.MouseEvent<HTMLButtonElement>, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      setIsModalOpen(false);
    }
  };

  return (
    <Box className='bg-head' py={3} minHeight='80vh'>
      <Container fixed>
        <Grid container spacing={3}>
          {/* {cartProducts?.loading === true ?
            <Box className='loader' minHeight={'50vh'}><CircularProgress sx={{ color: '#FB640A' }} /></Box> : */}
          {cartProducts.count === 0 ?
            <>
              <Grid item xs={12} textAlign={'center'} my={5}>
                <img src={cartImage} alt="Error" width={300} height={300} loading='lazy' />
              </Grid>
              <Grid item xs={12} textAlign={'center'}>
                <Button className='login-button reem-kulfi' onClick={() => navigate("/homepage")}>Browse menu</Button>
              </Grid>
            </> :
            <>
              <Grid item xs={12} md={6.5}>
                {/* merchant list section */}
                <Box display={'flex'} my={1}>
                  {cartProducts?.data[0]?.productDetails?.branch?.image.length > 0 && cartProducts?.data[0]?.productDetails?.branch?.image[0]?.filePath !== null ?
                    <img src={`${Gallery_BASE_URL}${cartProducts?.data[0]?.productDetails?.branch?.image[0]?.filePath}`} alt={cartProducts?.data[0]?.productDetails?.branch?.branchName} width='184px' height='146px' style={{ borderRadius: '18px', objectFit: 'cover' }} loading='lazy' /> :
                    <img src={merchantlogoEmpty} alt={cartProducts?.data[0]?.productDetails?.branch?.branchName} width='184px' height='146px' style={{ borderRadius: '18px', objectFit: 'cover' }} loading='lazy' />
                  }
                  <Box p={2} pt={3.75}>
                    <Typography mb={0.5} className='product-list-head inter-med' >{cartProducts?.data[0]?.productDetails?.branch?.branchName}<span style={cartProducts?.data[0]?.productDetails?.branch?.branchStatus === 'Closed' ? { color: 'red', marginLeft: '8px', fontSize: '14px' } : { color: 'green', marginLeft: '8px', fontSize: '14px' }}>({cartProducts?.data[0]?.productDetails?.branch?.branchStatus})</span></Typography>
                    <Typography mb={0.5} className='product-list-category-subCategory roboto-med'>{cartProducts?.data[0]?.productDetails?.branch?.categoryTypes.map((cuisine: any) => cuisine.name).join(', ')}</Typography>
                    <Typography mb={0.5} className='product-list-time roboto-med'>32 min</Typography>
                  </Box>
                </Box>
                <Box textAlign={'end'}>
                  <Button variant='text' onClick={backtoAddproduct} className='add-more-button reem-kulfi'>Add more</Button>
                </Box>
                {/* cart details section */}
                <Box className='cart-list' p={1} pt={0}>
                  {cartProducts.data && cartProducts.data.map((cart, index) => (
                    <Grid container spacing={2} key={index} justifyContent={'space-between'} alignItems={'center'} pt={1}>
                      <Grid item xs={12} sm={8.5} sx={cartProducts?.data[0]?.productDetails?.branch?.branchStatus === 'Closed' ? { filter: 'grayscale(100%)', pointerEvents: 'none' } : cart.productDetails?.isAvailable === false ? { filter: 'grayscale(100%)', pointerEvents: 'none' } : null}>
                        <Box display={'flex'}>
                          {cart?.productDetails?.images.length > 0 && cart?.productDetails?.images[0]?.filePath !== null ?
                            <img src={`${Gallery_BASE_URL}${cart?.productDetails?.images[0]?.filePath}`} alt="Merchant Image" width='120px' height='95px' style={{ borderRadius: '18px', objectFit: 'cover', aspectRatio:120 }} loading='lazy' /> :
                            <img src={productEmpty} alt="Merchant Image" width='120px' height='84px' style={{ borderRadius: '18px', objectFit: 'cover' }} loading='lazy' />}
                          <Box px={2} py={1}>
                            <Typography className='product-list-name roboto-med' >{`${cart?.productDetails?.productName} (${cart?.variantDetails?.variant?.variantName})`}</Typography>
                            <Typography className='product-card-list-category-subcategory roboto-med'>{cart?.productDetails?.description}</Typography>
                            <Typography className='product-card-price inter-med'>&#x20B9; {cart?.variantDetails?.price}</Typography>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={8} sm={1.75} display={'flex'} justifyContent={'end'} sx={cartProducts?.data[0]?.productDetails?.branch?.branchStatus === 'Closed' ? { filter: 'grayscale(100%)', pointerEvents: 'none' } : cart?.productDetails?.isAvailable === false ? { filter: 'grayscale(100%)', pointerEvents: 'none' } : null}>
                        <Box className='cart-list-button'>
                          <Button variant='text' className='cart-symbol-button' onClick={() => { handleSubCart(cart, index) }}>-</Button>
                          {indexLoading === index && cartUpdate.loading ?
                            <CircularProgress size={16} sx={{ color: '#FFFFFF', p: 0.25 }} /> :
                            indexLoading === index && cartDelete.loading ?
                              <CircularProgress size={16} sx={{ color: '#FFFFFF', p: 0.25 }} /> :
                              <Typography sx={{ color: '#FFFFFF', fontSize: '12px' }} mx={0.75}>{cart?.cartCount}</Typography>
                          }
                          <Button variant='text' className='cart-symbol-button' onClick={() => { handleAddCart(cart, index) }}>+</Button>
                        </Box>
                      </Grid>
                      <Grid item xs={4} sm={1.75} textAlign={'end'}>
                        <Button variant='text' disabled={cartDelete.loading} onClick={() => { handleDeleteCart(cart.id, index) }}>{deletIndexLoading === index && cartDelete.loading ? <CircularProgress size={20} sx={{ color: '#FC8019', p: 0.25 }} /> : <img src={deleteIcon} alt="Delete icon" loading='lazy' />}</Button>
                      </Grid>
                    </Grid>
                  ))}
                </Box>
              </Grid>
              <Grid item xs={12} md={5.5}>
                {/* address list section */}
                <Box className='address-list' my={1} p={3}>
                  {address.data.length > 0 ?
                    <>
                      {address.data.map((item, index) => (
                        item.isDefault === true ?
                          <Box key={index}>
                            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
                              <Box className='delivery-address-head'>
                                <Typography className='address-head roboto-med'>Delivery Address</Typography>
                              </Box>
                              <Box width={'35%'} textAlign='end'>
                                <Button variant='text' onClick={handleChangeDeliveryAddress} className='addressChange'><img src={addressIcon} alt="Address Icon" width={33} height={29} loading='lazy' /> <span style={{ color: '#FB640A', marginLeft: '8px' }}>change</span></Button>
                              </Box>
                            </Box>
                            <Typography className='delivery-address roboto-med' mt={0.5}>{item?.addressType}</Typography><Box width={'70%'} mt={1}>
                              <Typography className='address roboto-med'><span>{item?.contactName}, <br /></span> {`${item?.streetAddress}, ${item?.area}-${item?.zipCode}, ${item?.landMark},`}<br /> Ph-no: {item?.contactNo}</Typography>
                            </Box>
                          </Box> : null
                      ))}
                    </> :
                    <Box textAlign={'center'}>
                      <Button className='profile-edit-button' onClick={handleAddAddress}>
                        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} p={1} pb={0.25}>
                          <img src={newAddress} alt="Address Icon" width={25} height={25} loading='lazy' /><Typography className='address roboto-med'>Add New Address</Typography>
                        </Box>
                      </Button>
                    </Box>}
                </Box>
                {/* coupon section */}
                {cartProducts?.billDetails?.isCoupenApplied || cartProducts?.billDetails?.isOfferApplied ?
                  <Box className='coupon-applied-list' my={2} px={3} py={1.5} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography sx={{ textTransform: 'uppercase' }} className='bill-head roboto-med'>{CouponCode ? CouponCode : OfferCode}</Typography>
                      <Typography className='promo-text roboto-med'>{cartProducts?.billDetails?.isCoupenApplied ? 'Coupon applied on the bill' : "Offer applied on the bill"}</Typography>
                    </Box>
                    <Button variant='text' className='promo-remove' disabled={cartProducts?.loading} onClick={removeCoupon}>{cartProducts?.loading ? <CircularProgress size={20} sx={{ color: '#FC8019', p: 0.25 }} /> : <>Remove</>}</Button>
                  </Box> :
                  <Box className='coupon-list' my={2} pl={1} style={{ display: 'flex', alignItems: 'center' }}>
                    <Controller
                      name="coupon"
                      control={control}
                      render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <TextField
                          margin="normal"
                          fullWidth
                          disabled
                          className='border-coupon'
                          id="coupon"
                          placeholder="Offers"
                          name="coupon"
                          value={cartProducts?.billDetails?.isCoupenApplied ? 'Coupen applied' : '' || cartProducts?.billDetails?.isOfferApplied ? "Offer applied" : ''}
                          onChange={onChange}
                          error={!!error}
                          helperText={error ? error.message : null}
                          InputProps={{
                            autoComplete: 'off',
                            sx: {
                              borderRadius: '8px',
                              paddingBottom: '8px'
                            }
                          }}
                        />
                      )}
                    />
                    <Button variant='contained' className='coupon-button reem-kulfi' size='small' onClick={toggleDrawer("right", true)} disabled={cartProducts?.loading}>{cartProducts?.loading ? <CircularProgress size={20} sx={{ color: '#FFFFFF', p: 0.25 }} /> : <>Apply&nbsp;<ArrowForwardOutlinedIcon /></>}</Button>
                    <Drawer
                      anchor={'right'}
                      open={state['right']}
                      onClose={toggleDrawer('right', false)}
                    >
                      {list('right')}
                    </Drawer>
                  </Box>}
                {/* bill details section */}
                <Box className='bill-details' p={2}>
                  <Box textAlign={'center'}>
                    <Typography className='bill-head roboto-med'>Bill Details</Typography>
                  </Box>
                  <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} my={2}>
                    <Typography className='bill-head roboto-med'>Item Total</Typography>
                    <Typography className='bill-head roboto-med'>&#x20B9; {cartProducts?.billDetails?.totAmt}</Typography>
                  </Box>
                  {cartProducts?.billDetails?.isCoupenApplied || cartProducts?.billDetails?.isOfferApplied ?
                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} my={2}>
                      {cartProducts?.billDetails?.isCoupenApplied ?
                        <Typography className='bill-Offer roboto-med'>Coupon amount</Typography> :
                        cartProducts?.billDetails?.isOfferApplied ?
                          <Typography className='bill-Offer roboto-med'>Offer amount</Typography> :
                          null
                      }
                      {cartProducts?.billDetails?.isCoupenApplied ?
                        <Typography className='bill-price roboto-med'>&minus; &#x20B9; {cartProducts?.billDetails?.coupenAmount}</Typography> :
                        cartProducts?.billDetails?.isOfferApplied ?
                          <Typography className='bill-price roboto-med'>&minus; &#x20B9; {cartProducts?.billDetails?.offerAmount}</Typography> :
                          null
                      }
                    </Box> : null
                  }
                  <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Link to="#" className='delivery-link roboto-med'>Delivery charge</Link>
                    <Typography className='bill-delivery roboto-med'>&#x20B9; {cartProducts?.billDetails?.dlvCharges}</Typography>
                  </Box>
                  <hr color='#DADADA' />
                  <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Typography className='bill-head roboto-med'>Sub Total</Typography>
                    <Typography className='bill-head roboto-med'>&#x20B9; {cartProducts?.billDetails?.subTotalAmt}</Typography>
                  </Box>
                </Box>
                {/* <Box width={'100%'} mt={2}>
                <RadioGroup
                  aria-labelledby="demo-error-radios"
                  name="quiz"
                  className='radio-cash'
                >
                  <FormControlLabel 
                  value="end" labelPlacement="start" control={<Radio className='label-cash' color='warning'/>}label="Cash on delivery" />
                </RadioGroup>
              </Box> */}
                {/* order details section */}
                <Box textAlign={'center'} my={2} sx={cartProducts?.data[0]?.productDetails?.branch?.branchStatus === 'Closed' ? { filter: 'grayscale(100%)', pointerEvents: 'none' } : cartProducts?.billDetails?.totAmt === '0' ? { filter: 'grayscale(100%)', pointerEvents: 'none' } : null}>
                  <Button variant='contained' className='payment-proceed-button roboto-med' onClick={() => handleCheckout(address, cartProducts)} sx={{ width: '100%' }} disabled={orderDetails?.loading}>
                    {orderDetails?.loading ? <CircularProgress size={20} sx={{ color: '#FFFFFF', p: 0.25 }} /> : 'Proceed to checkout'}</Button>
                </Box>
              </Grid>
            </>}
        </Grid>
        {isSnackbarOpen && (
          <AppSnackbar
            showAlert={isSnackbarOpen}
            message={cartUpdate?.message || orderDetails.message || cartDelete.message}
            type="success"
            onClose={handleSnackbarClose}
          />
        )}
        {isErrorSnackbarOpen && (
          <AppSnackbar
            showAlert={isErrorSnackbarOpen}
            message={cartUpdate?.message || orderDetails.message}
            type="error"
            onClose={handleSnackbarClose}
          />
        )}
        <GoToTop />
        <AddAddress isOpen={isModalOpen} onClose={handleAddressModalClose} id={undefined} />
      </Container>
    </Box>
  )
}

export default CartAddList